module.exports = __webpack_public_path__ + "static/media/background-qrcode.2ed3dd83.jpg";